<app-stepper-form
  header="Notification by Officeholder of Resignation or Retirement"
  subheader="Form 370"
  formIcon="ic-notification-by-officeholder-20"
  [steps]="steps"
  [currentStep]="currentStep"
  [currentStepIndex]="currentStepIndex"
  [form]="stepperForm"
  [isLoading]="isLoading"
  [showSteps]="false"
>
  <div class="step-content" [formGroup]="stepperForm">
    <app-stepper-form-description
      formKey="370"
      [hidden]="currentStep !== StepsEnum.FormDescription"
    />

    <section
      class="step-section"
      [formGroupName]="StepsEnum.ResignationDetails"
      [hidden]="currentStep !== StepsEnum.ResignationDetails"
    >
      <h1 class="h1-heading">Resignation Details</h1>

      <div class="form-group">
        <app-date-picker
          label="Date of Resignation"
          formControlName="changeDate"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [customErrors]="customDatepickerErrors"
        />
      </div>

      <div class="form-group">
        <app-date-picker
          label="Date the letter handed in"
          formControlName="resignationLetterGiven"
          [minDate]="minDate"
          [maxDate]="maxDate"
          [customErrors]="customDatepickerErrors"
        />
      </div>

      <div class="form-group">
        <app-yes-no-control
          label="Select Existing Officer?"
          formControlName="isFormerOfficerResignation"
          [reversedValues]="true"
        />
      </div>

      <div class="form-group" [hidden]="form.controls.isFormerOfficerResignation.value !== false">
        <app-select
          label="Resigning Officer"
          formControlName="appointedOfficerId"
          [options]="officersSelectOptions"
          [valuePrimitive]="true"
        />
      </div>

      <div class="form-group" [hidden]="form.controls.isFormerOfficerResignation.value !== true">
        <app-individual-data-form-group [formGroup]="form.controls.formerOfficeholder"/>
      </div>


      <div class="form-group">
        <app-checkbox-group
          formControlName="types"
          [options]="officerTypesOptions"
        />
      </div>

      @if (isTheOnlyDirectorSelected && form.value.appointedOfficerId) {
        <app-notification
          class='mr-3'
          color="red"
          [text]="ceaseWarningMsg"
        />
      }

      <div class="form-group" [hidden]="form.controls.isFormerOfficerResignation.value === null">
        <app-textarea
          label="Resignation Letter"
          formControlName="resignationLetterText"
          [rows]="4"
        />
      </div>
    </section>
  </div>
</app-stepper-form>
